export default __webpack_public_path__ + "static/media/logo-isa-mini.472dedd6.svg";